import { styled, useTheme } from "@mui/material";
import Button from "@mui/material/Button";

const CommonButton = ({ style = "gradient", text = "", sx ,onClick}) => {
  const theme = useTheme();
  let sty = {backgroundColor : "#0e0e0e",color: "#fff",
        width: "86px",
        height: "37px",
        borderRadius:'5px',
        ...sx}
  
  if (style == "gradient") {
    sty['background'] = theme.palette.customGradient.primaryGradient;
  }
  else if(style === "transparent"){
    sty['background'] = '#fff'
    sty['border'] = `2px solid ${theme.palette.borders.default}`
    sty['color'] = theme.typography.colorGrey
    
  }
  return (
    
    <Button
      sx={{...sty}}
      onClick={onClick}
    >
      {text}
    </Button>
  );
};

export default CommonButton;
